import { render, staticRenderFns } from "./AvatarEditor.vue?vue&type=template&id=b6dd3620&scoped=true"
import script from "./AvatarEditor.vue?vue&type=script&lang=ts"
export * from "./AvatarEditor.vue?vue&type=script&lang=ts"
import style0 from "./AvatarEditor.vue?vue&type=style&index=0&id=b6dd3620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dd3620",
  null
  
)

export default component.exports